// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3mW7f","list":"BalanceDue_list__Puqal","listRow":"BalanceDue_listRow__1foWZ","total":"BalanceDue_total__zWmyt"};